import React, { lazy, useEffect, useState } from 'react';

import { PageLevel } from '@/components/PageContainer';
import PageHeader from '@/components/PageContainer/PageHeader';
import Spin from '@/components/Spin';
import { useFingerPrint } from '@/hooks/useFingerPrint';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useI18nContext } from '@/i18n/I18n';

import Main from './Main';
// const Main = lazy(() => {
//   return import('./Main');
// });

const App = () => {
  const [$t] = useI18nContext();
  const { profile, isSubmember } = useUserProfile();
  const { fingerReport } = useFingerPrint();

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (profile?.result?.id) {
      fingerReport('wf01', '1');
    }
  }, [profile]);

  useEffect(() => {
    if (isSubmember) {
      document.title = $t('subaccountInfo');
    }
  }, [isSubmember, $t]);

  return (
    <>
      <PageHeader
        pageLevel={PageLevel.main}
        pageTitle={isSubmember ? $t('subaccountInfo') : $t('accountBaseInfo')}
      />
      <Main loadFn={() => setLoaded(true)} />
      {!profile?.result?.id && (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100vh',
          }}
        >
          <Spin spinning={!profile?.result?.id}>
            <div style={{ height: '100vh' }}></div>
          </Spin>
        </div>
      )}
    </>
  );
};

export default App;
